module.exports = __webpack_public_path__ + "img/Person.98e1d50c.svg";